import { types as sdkTypes } from './sdkLoader';

const { Money } = sdkTypes;

export const FIXED_FEE_TYPE_ONE_TIME = 'one_time';
export const MAX_FIXED_FEE_LABEL_LENGTH = 80;
export const MAX_FIXED_FEES = 5;

export const normalizeFixedFeeLabel = label => {
  return typeof label === 'string'
    ? label
        .trim()
        .replace(/\s+/g, ' ')
        .slice(0, MAX_FIXED_FEE_LABEL_LENGTH)
    : '';
};

export const normalizeFixedFees = (fixedFees = [], fallbackCurrency) => {
  return Array.isArray(fixedFees)
    ? fixedFees
        .map(fee => {
          const label = normalizeFixedFeeLabel(fee?.label);
          const amount = fee?.amount;
          const currency = fee?.currency || fallbackCurrency;
          const hasValidAmount = Number.isInteger(amount) && amount > 0;
          const hasValidCurrency = !fallbackCurrency || currency === fallbackCurrency;

          return label && hasValidAmount && hasValidCurrency
            ? {
                label,
                amount,
                currency,
                type: FIXED_FEE_TYPE_ONE_TIME,
              }
            : null;
        })
        .filter(Boolean)
        .slice(0, MAX_FIXED_FEES)
    : [];
};

export const fixedFeesForForm = (fixedFees = [], fallbackCurrency) => {
  return normalizeFixedFees(fixedFees, fallbackCurrency).map(fee => ({
    label: fee.label,
    amount: new Money(fee.amount, fee.currency),
  }));
};

export const fixedFeesForPublicData = (fixedFees = [], fallbackCurrency) => {
  const fees = Array.isArray(fixedFees) ? fixedFees : [];

  return normalizeFixedFees(
    fees.map(fee => ({
      label: fee?.label,
      amount: fee?.amount instanceof Money ? fee.amount.amount : fee?.amount,
      currency: fee?.amount instanceof Money ? fee.amount.currency : fee?.currency,
    })),
    fallbackCurrency
  );
};
